import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Interceramic_Title } from '../../../../../utils/EN/Modals/CorpModals';

const ModalCoprInterceramic = () => {
  return (
    <>
      <ModalVideo
        id="corporate-interceramic"
        dataText={Interceramic_Title}
        videoSrc="https://player.vimeo.com/video/238807610?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_INTERCERAMIC"
      />
    </>
  );
};

export default ModalCoprInterceramic;
